import { useEffect, useState } from 'react'

let externalTrigger = null

// Minimal in-app toast. Called from anywhere via `showToast(message)`.
export function showToast(message) {
  externalTrigger?.(message)
}

export default function Toast() {
  const [message, setMessage] = useState('')
  useEffect(() => {
    externalTrigger = (m) => {
      setMessage(m)
      window.clearTimeout(externalTrigger._t)
      externalTrigger._t = window.setTimeout(() => setMessage(''), 2400)
    }
    return () => {
      externalTrigger = null
    }
  }, [])
  if (!message) return null
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4">
      <div className="pointer-events-auto rounded-full bg-navy px-4 py-2 text-[12px] font-bold text-white shadow-lg">
        {message}
      </div>
    </div>
  )
}
